import { render } from "./EndOfList.vue?vue&type=template&id=3643a591&scoped=true&ts=true"
import script from "./EndOfList.vue?vue&type=script&lang=ts"
export * from "./EndOfList.vue?vue&type=script&lang=ts"

import "./EndOfList.vue?vue&type=style&index=0&id=3643a591&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3643a591"]])

export default __exports__